window.onload = function(){

  var _main = document.getElementsByTagName('main')[0];
  var _fixedText = document.getElementsByClassName('fixed--txt');

  //data-section-type="header"
  var _an = document.getElementsByClassName('cc-announcement')[0];


  var rellax = new Rellax('.deco');
  window.styleSwiper = new Swiper('.swiper-style', {
    // Optional parameters
    loop: true,
    centeredSlides: true,
    slidesPerView: 3,
    spaceBetween: 40,
    speed: 1000,

    autoplay: {
      delay: 1000,
      disableOnInteraction: true,
      pauseOnMouseEnter: false,
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      1440: {
        spaceBetween: 30,
      },
      787: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
  });

  var _swiperContent = document.getElementById('style_swiper');
  var _content3 = document.getElementById('top_content3');
  var _content3ChangeImageContainer = document.getElementsByClassName('top-content3-change');

  var _stopTimer = null;
  var _StopSwiper = function(){
    if(_stopTimer){
      clearInterval(_stopTimer);
    }
    _stopTimer = setInterval(function(){
      if(!styleSwiper.autoplay.paused){
        styleSwiper.autoplay.pause();
        clearInterval(_stopTimer);
      }
    }, 100);

  };

  var _StartSwiper = function(){
    console.log(styleSwiper.autoplay.paused);
    if(styleSwiper.autoplay.paused){
      styleSwiper.autoplay.run();
      styleSwiper.autoplay.running = true;
    }else if(!styleSwiper.autoplay.running){
      styleSwiper.autoplay.run();
      styleSwiper.autoplay.running = true;
    }
  };

  _swiperContent.addEventListener('mouseenter', _StopSwiper);
  _swiperContent.addEventListener('mouseleave', _StartSwiper);
  //_swiperContent.addEventListener('mouseout', _StartSwiper);

  var _ChangeImage = function(container, num){
    var __children = container.getElementsByTagName('div');
    var __current = 1;
    var __len = __children.length;

    var _parent = container.parentNode;
    var _slideIndex = _parent.getAttribute('data-swiper-slide-index');

    var __Change = function(){

      for(var c = 0; c < __children.length; c++){
        __children[c].classList.remove('is-appear')
      }

      __children[__current].classList.add('is-appear');

      __current++;
      if(__current === __len){
        __current = 0;
      }
    };

    var __timeout = setTimeout(function(){
      var __intervar = setInterval(__Change, 3000);
      clearTimeout(__timeout);
    }, 300 * _slideIndex);
  };

  for(var c = 0; c < _content3ChangeImageContainer.length; c++){
    _ChangeImage(_content3ChangeImageContainer[c], c);
  }



  var _btns = document.getElementsByClassName('top-content--btn');
  var _agent = navigator.userAgent.toLocaleLowerCase();
  var _isSP = _agent.indexOf('iphone') > 0 || _agent.indexOf('android') > 0 && _agent.indexOf('mobile') > 0 || _agent.indexOf('ipad') > 0 || _agent.indexOf('android') > 0;

  var _event = {
    mousedown: _isSP ? "touchstart" : "mousedown",
    mouseup: _isSP ? "touchend" : "mouseup",
    mouseleave: _isSP ? "touchmove" : "mouseleave"
  };


  var _video = document.getElementById('mv_video');
  var _videoSp = document.getElementById('mv_video_sp');
  var _pcUrl = _video.getAttribute('data-pc-url');
  var _spUrl = _video.getAttribute('data-sp-url');

  var _Resize = function(){
    if(window.outerWidth > 767){
      if(_isSP){
        _isSP = false;
        _video.play();
        _videoSp.pause();
      }
    }else{
      if(!_isSP){
        _isSP = true;
        _video.pause();
        _videoSp.play();
      }
    }
    if(_an){
      var _anHeight = _an.clientHeight;
      _video.style.marginTop = _anHeight + 'px';
    }
  };
  window.addEventListener('resize', _Resize);
  _Resize();

  if(window.outerWidth > 767){
    _isSP = false;
    _video.play();
    _videoSp.pause();
  }else{
    _isSP = true;
    _video.pause();
    _videoSp.play();
  }

  console.log('changed e');

};